$(document).ready(function () {
    $(function () {
        // preventing page from redirecting
        $("html").on("dragover", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(".js_image_load").text("Drag here");
            $(".remove").remove()
        });

        $("html").on("drop", function (e) { e.preventDefault(); e.stopPropagation(); });

        // Drag enter
        $('.upload-area').on('dragenter', function (e) {
            e.stopPropagation();
            e.preventDefault();
            $(".js_image_load").text("Drop");
            $(".remove").remove()
        });

        // Drag over
        $('.upload-area').on('dragover', function (e) {
            e.stopPropagation();
            e.preventDefault();
            $(".js_image_load").text("Drop");
            $(".remove").remove()
        });

        // Drop
        $('.upload-area').on('drop', function (e) {
            e.stopPropagation();
            e.preventDefault();

            $(".js_image_load").text("Upload");
            $(".remove").remove()

            var file = e.originalEvent.dataTransfer.files;
            var fd = new FormData();

            fd.append('file', file[0]);

            uploadData(fd);
        });

        // Open file selector on div click
        $("#uploadfile").click(function () {
            $("#file").click();
        });

        // file selected
        $("#file").change(function () {
            var fd = new FormData();
            var files = $('#file')[0].files[0];
            fd.append('file', files);

            uploadData(fd);
        });
    });

    // Sending AJAX request and upload file
    function uploadData(formdata) {
        $.ajax({
            url: routes.addFileResume,
            type: 'post',
            data: formdata,
            contentType: false,
            processData: false,
            dataType: 'json',
            success: function (response) {
                $('#file').addClass('photo_add');
                addThumbnail(response);
            }
        });
    }

    // Added thumbnail
    function addThumbnail(data) {
        let count = Number($('.js_count').text()) + 1;

        let file_name = data.file_name;
        let file_path = data.file_path;
        $('.js_list_file').append(`<li class="js__file_list file_list">
        <a target="_blank" href="${file_path}">${file_name}</a>
        <button type="button" class="js__remove_file" data-name="${file_name}">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 1L1 9" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M1 1L9 9" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        </button>
        <input type="hidden" value="${file_name}" class="js__file_add_hidden" name="file_${count}"></input>
        </li>`);

        $('.container_dd_wrap').removeClass('error_input');
        $('.js_count').text(count);
    }



    $(document).on('click', '.js__remove_file', function() {
        const name = $(this).attr('data-name');
        const block = $(this).closest('.js__file_list');

        $.post(routes.removeFile, {
            "name": name
        }, function(data) {
            if (data.status == 'ok') {
                block.remove();
            }
        });
    });
});


// WEBPACK FOOTER //
// ./resources/js/components/drop.js